import { useQuery } from '@apollo/client'
import { useEffect, useState } from 'react'
import { GET_BANK_DETAILS_BY_ID } from '../../graphql/Query/SellerPruff.js'
import Table from "../../components/Table/index.jsx";

const AdminCustomerProfileDetail = ({ location }) => {
    const [orderData, setOrderData] = useState([]);

    const { data, loading } = useQuery(GET_BANK_DETAILS_BY_ID, {
        variables: {
            customerId: location?.customerId
        },
        fetchPolicy: "cache-and-network"
    });

    useEffect(() => {
        if (data?.getBankDetailsById) {
            setOrderData([data.getBankDetailsById]);
        }
    }, [data]);


    const columns = [
        {
            name: "Bank Holder Name",
            selector: (row) => row?.bankHolderName ?? "-",
            sortable: true,
            cell: (row) => <span className="text-xs">{row?.bankHolderName ?? "-"}</span>
        },
        {
            name: "Account Number",
            selector: (row) => row?.accountNumber ?? "-",
            sortable: true,
            cell: (row) => (
                <span className="text-xs">
                    {row?.accountNumber}

                </span>
            )
        },
        {
            name: "IFSC Code",
            selector: (row) => row?.ifscCode ?? "-",
            sortable: true,
            cell: (row) => <span className="text-xs">{row?.ifscCode ?? "-"}</span>
        },
        {
            name: "Bank Name",
            selector: (row) => row?.bankName ?? "-",
            sortable: true,
            cell: (row) => <span className="text-xs">{row?.bankName ?? "-"}</span>
        },
        {
            name: "Branch Name",
            selector: (row) => row?.branch ?? "-",
            sortable: true,
            cell: (row) => <span className="text-xs">{row?.branch ?? "-"}</span>
        },
        {
            name: "City",
            selector: (row) => row?.city ?? "-",
            sortable: true,
            cell: (row) => <span className="text-xs">{row?.city ?? "-"}</span>
        },
        {
            name: "State",
            selector: (row) => row?.state ?? "-",
            sortable: true,
            cell: (row) => <span className="text-xs">{row?.state ?? "-"}</span>
        },
        {
            name: "Account Type",
            selector: (row) => row?.accountType ?? "-",
            sortable: true,
            cell: (row) => (
                <span className="text-xs">{typeof row?.accountType === "object" ? row.accountType.label : row?.accountType}</span>
            )
        },
        {
            name: "GST Number",
            selector: (row) => row?.gstNumber ?? "-",
            sortable: true,
            cell: (row) => <span className="text-xs">{row?.gstNumber ?? "-"}</span>
        },

    ];


    return (
        <div>
            <div className="mt-2 bg-white p-4 border rounded-lg">
                <Table
                    columns={columns}
                    data={orderData}
                    loading={loading}
                />
            </div>
        </div>
    );
};


export default AdminCustomerProfileDetail
